import { render, staticRenderFns } from "./DetalleVODModal.vue?vue&type=template&id=81e3ed2a&"
import script from "./DetalleVODModal.vue?vue&type=script&lang=ts&"
export * from "./DetalleVODModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports